import Resource from '@/plugins/sdk/Resource'
import { STRING, ITEM, UUID, DATETIME } from '@/plugins/sdk/fields'
import Consignment from '../Consignment'
import Type from './Type'

export default class extends Resource {
  static name = 'tracking_subscription'

  static get fields () {
    return {
      id: new UUID(),
      type: new ITEM(Type),
      consignment: new ITEM(Consignment),
      email: new STRING(),
      created_at: new DATETIME(),
      updated_at: new DATETIME()
    }
  }
}
